import React, { useEffect } from 'react';
import { makeStyles, Box } from '@material-ui/core';
import Page from 'src/app/components/Page';
import MapTracking from './MapTracking';
import useVehicleTracking from 'src/app/hooks/useVehicleTracking';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getListDeviceType } from 'src/features/deviceTypeSlice';
import './style.css';
import { resetListVehicle } from 'src/features/vehicleSlice';
const TrackingView = () => {
  const classes = useStyles();
  useVehicleTracking();

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getListDeviceType());
    return () => {
      dispatch(resetListVehicle());
    }
  }, [dispatch]);


  return (
    <Page className={classes.root}>
      <Box className="flex tracking-view-shell" style={{ position: 'relative' }}>
        <MapTracking />
      </Box>
    </Page>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#f8f9fa',
    paddingLeft: 0,
    paddingRight: 0,
    height: '100%'
  }
}));


const TrackingGuard = () => {
  const { isAccountant, isSale, dataLogin } = useSelector(state => state.authSlice);
  const token = localStorage.getItem('access-token');

  if (token && !dataLogin) return null;

  if (isAccountant || isSale) {
    return <Navigate to="/app/manage/sales-orders" replace />;
  }

  return <TrackingView />;
};

export default React.memo(TrackingGuard);
